"use strict";

var _a;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultErrorMessages = exports.ERROR_CODES = void 0;
exports.ERROR_CODES = {
  elementMountError: 'element-mount-error',
  initializeError: 'initialize-error',
  remoteScriptError: 'remote-script-error'
};
exports.defaultErrorMessages = (_a = {}, _a[exports.ERROR_CODES.remoteScriptError] = "Can't load the FramePay remote script", _a[exports.ERROR_CODES.elementMountError] = "Can't mount the element component", _a[exports.ERROR_CODES.initializeError] = "\n        FramePay initialize error\r\n\n        See https://github.com/Rebilly/framepay-react/tree/alpha#the-framepay-context-framepayprovider\r\n\n        See https://rebilly.github.io/framepay-docs/reference/rebilly.html#rebilly-initialize", _a);

var ErrorBuilder = function () {
  function ErrorBuilder() {}

  ErrorBuilder.prototype.make = function (_a) {
    var code = _a.code,
        details = _a.details,
        trace = _a.trace;
    return {
      code: code,
      details: details,
      message: exports.defaultErrorMessages[code],
      trace: trace || null
    };
  };

  return ErrorBuilder;
}();

var handler = new ErrorBuilder();

var FramePayError = function FramePayError(_a) {
  var code = _a.code,
      _b = _a.details,
      details = _b === void 0 ? '' : _b,
      _c = _a.trace,
      trace = _c === void 0 ? '' : _c;
  return handler.make({
    code: code,
    details: details,
    trace: trace
  });
};

FramePayError.codes = exports.ERROR_CODES;
exports.default = FramePayError;